import type { ReactNode } from 'react';
import { Badge } from '@govinity/ui/components/ui/badge';

type MeetingTabWrapperProps = {
  actions?: ReactNode;
  children: ReactNode;
  countLabel?: string;
  description?: string;
  title: string;
};

export function MeetingTabWrapper({
  actions,
  children,
  countLabel,
  description,
  title,
}: MeetingTabWrapperProps) {
  return (
    <div className="space-y-6">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="text-lg font-semibold">{title}</h2>
          {!!description && <p className="text-muted-foreground mt-1">{description}</p>}
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {actions}
          {countLabel ? (
            <Badge variant="outline" className="text-xs">
              {countLabel}
            </Badge>
          ) : null}
        </div>
      </div>
      {children}
    </div>
  );
}
